import { UserType } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useFeatureFlag } from "./useFeatureFlag";

export const useIsCommercialSuretyEnabled = () => {
	const { user } = useAuthenticatedUser();
	const isCommercialSuretyEnabled = useFeatureFlag("commercial_surety");
	const isAgentCommercialExperienceEnabled = useFeatureFlag("agent_commercial_experience");

	if (user?.type === UserType.admin) return isCommercialSuretyEnabled;
	if (user?.type === UserType.agent) {
		return isCommercialSuretyEnabled && isAgentCommercialExperienceEnabled;
	}
	return false;
};
